import React from 'react'


/**
 * Input filter hooked up to ReactTable filter.
 * Allow user input date range to filter the records
 * TODO: create Date Range Column Filter
 */
const DateRangeColumnFilter = () => (
  <div></div>
)

export default DateRangeColumnFilter